import {ProspectPool} from 'api';
import React from 'react';
import {Row} from 'react-table';
import moment from 'moment';

interface Props {
  row: Row<ProspectPool>;
}

const TodoDate = ({row}: Props) => {
  const prospectPool = row.original;

  if (!prospectPool.task?.dueDate) {
    return <></>;
  }

  return <div>{moment(prospectPool.task.dueDate).format('YYYY/MM/DD')}</div>;
};

export default TodoDate;
